// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__2fqWA","errorLogs":"styles_errorLogs__3jHfD"};